module.exports = __webpack_public_path__ + "img/activityRules.9f597d40.png";